import clsx from 'clsx'

export default function Circle({ className = undefined }: { className?: string }) {
  return <div className={clsx('w-28 h-28 rounded-full bg-co-fuscous-gray pointer-events-none', className)} />
}
